export const de = {
  title: "Berechnen Sie Reichweite und Höhe des Löschmittelstrahls",
  text: "Bitte wählen Sie in der nachstehenden Animation einen Löschmonitor und seinen Düsentyp aus. Nachdem Sie Ihre Betriebsbedingungen eingestellt haben, sehen Sie die Reichweite und Höhe des Löschmittelstrahls sowie die entstehende Rückstoßkraft. Gern können Sie das Ergebnis auch als PDF ausgeben lassen.",
  components: {
    addButton: {
      defaultAriaLabel: "Hinzufügen",
    },
    languageSwitcher: {
      english: "Englisch",
      german: "Deutsch",
      french: "Französisch",
      imp: "Imperial",
      met: "Metrisch",
    },
    obstacleFormInput: {
      depth: "Tiefe",
      distance: "Entfernung",
      height: "Höhe",
    },
    resultsTextualSummary: {
      range: "Reichweite",
      throwingHeight: "Wurfhöhe",
      distanceOfHeighestPoint: "Entfernung höchster Punkt",
      recoil: "Rückstoßkraft",
      footprintDiameter: "Durchmesser der Auftrefffläche",
    },
    settings: {
      title: "Einstellungen",
      headlineAngle: "Winkel",
      headlineExtinguishingAgentFlow: "Löschmittelstrom",
      headlineGroundObstacle: "Bodenhindernis",
      headlineMedium: "Medium",
      headlineMonitorHeight: "Monitorhöhe",
      headlinePressure: "Druck (am Eingangsflansch)",
      headlineRoofObstacle: "Deckenhindernis",
      obstacleLabel: "Hindernis",
      obstacleLabelWithNumber: "Hindernis {{obstacleNumber}}",
      nozzleOption: "DÜSE: {{nozzleName}}",
      mediumFoam: "Schaum",
      mediumWater: "Wasser",
      monitorOption: "MONITOR: {{monitorName}}",
    },
    removeButton: {
      defaultAriaLabel: "Entfernen",
    },
    results: {
      title: "Ergebnis",
      footerText:
        "Die Reichweitenmessung erfolgt vom Auswurfpunkt am Löschmonitor bis zum Mittelpunkt der Auftrefffläche bei nahezu Windstille.",
      buttonInfo: "Erklärungen",
      buttonPdf: "PDF exportieren",
    },
    chart: {
      rangeInMeters: "Reichweite in Meter",
      heightInMeters: "Höhe in Meter",
      rangeInFoot: "Reichweite in Fuß",
      heightInFoot: "Höhe in Fuß",
    },
    pdfExport: {
      createdAt: "Erstellt am {{dd}}.{{mm}}.{{yyyy}}",
      footerLinkLabel: "www.firedos.de",
    },
  },
  formatting: {
    numberWithoutDecimalPoints: "{{number, number(maximumFractionDigits: 0)}}",
    numberMaxOneDecimalPoint: "{{number, number(maximumFractionDigits: 1)}}",
    numberMaxTwoDecimalPoints: "{{number, number(maximumFractionDigits: 2)}}",
    numberMaxFourDecimalPoints: "{{number, number(maximumFractionDigits: 4)}}",
  },
  units: {
    bar: "bar",
    kiloNewton: "kN",
    literPerMinute: "l/min",
    meter: "m",
    foot: "ft",
    gallonPerMinute: "gal/min",
    psi: "psi",
  },
};
